import React, {useEffect,useState} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { MDBDataTableV5 } from 'mdbreact';
import { Typeahead } from 'react-bootstrap-typeahead';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../assets/scss/app-styles/shared-vm.scss'
import '../../assets/scss/app-styles/extensions.scss'

const SharedDids = (props) => {
    const [sharedDidsList, setSharedDidsList] = useState([]);
    const [selectedDid, setSelectedDid] = useState("");
    const [selectedSubscriber, setSelectedSubscriber] = useState("");
    const [didsList, setDidsList] = useState([]);
    const [tableData, setTableData] = useState({
        columns: [
            {
                label: 'User',
                field: 'user',
                width: 150,
            },
            {
                label: 'DID',
                field: 'did',
                width: 150,
            },
            {
                label: 'Delete',
                field: 'delete',
                width: 100,
            },
        ],
        rows: []
    });

    const headers = {
        headers: {
            Token: localStorage.getItem("token"),
        }
    }

    const fetchDIDNumbers = async () => {
        try {
            const payload = {
                cloud_id: JSON.parse(localStorage.getItem('creds')).cloud_id,
                username: props.sharedDidUser + "@" + props.domain
            };
            const response = await axios.post(process.env.REACT_APP_API_URL + "getDIDNumbers", payload, headers);
            setDidsList(response.data);
            setSelectedDid(response.data[0]);
        } catch (error) {
            console.error('Error fetching DID numbers:', error);
            toast.error('Failed to fetch DID numbers');
        }
    };

    const fetchSharedDIDDetails = async () => {
        try {
            const payload = {
                cloud_id: JSON.parse(localStorage.getItem('creds')).cloud_id,
                username: props.sharedDidUser,
                domain: props.domain
            };
            const response = await axios.post(process.env.REACT_APP_API_URL + "getDidSharingDetails", payload, headers);
            
            if (response?.data) {
                const rows = response.data?.map(item => ({
                    user: item.secondary_user,
                    did: item.did,
                    delete: (
                        <i className="fa fa-trash" 
                           style={{color: "red", cursor: "pointer"}} 
                           onClick={() => deleteSharedDidsHander(item.secondary_user, item.did)}/>
                    )
                }));

                setTableData(prevState => ({
                    ...prevState,
                    rows: rows
                }));
            }
        } catch (error) {
            console.error('Error fetching SMS DID details:', error);
            toast.error('Failed to fetch SMS DIDs');
        }
    };

    useEffect(() => {
        if (props.show) {
            fetchDIDNumbers();
            fetchSharedDIDDetails();
        }
    }, [props.show]);

    const didChangeHandler = (evt) => {
        setSelectedDid(evt.target.value);
    }

    const deleteSharedDidsHander = (user, did) => {
        const payload = {
            cloud_id: JSON.parse(localStorage.getItem('creds')).cloud_id,
            secondary_user: user,
            primary_user: props.sharedDidUser,
            domain: props.domain,
            did_number: did
        };

        axios.post(process.env.REACT_APP_API_URL + "deleteDidSharing", payload, headers)
            .then(response => {
                setTableData(prevState => ({
                    ...prevState,
                    rows: prevState.rows.filter(row => !(row.user === user && row.did === did))
                }));
                toast.success('DID sharing removed successfully');
            })
            .catch(error => {
                console.error('Error deleting DID sharing:', error);
                toast.error('Failed to remove DID sharing');
            });
    }

    const subscriberChangeHandler = (result) => {
        if(result.length === 0){
            setSelectedSubscriber("");
            return;
        }
        setSelectedSubscriber(result[0].user);
    }

    const addSubscriberHandler = () => {
        if (!selectedSubscriber || !selectedDid) {
            toast.info("Please select a subscriber and a DID");
            return;
        };
        
        // Check if the combination already exists
        const isDuplicate = tableData.rows.some(
            row => row.user === selectedSubscriber && row.did === selectedDid
        );

        if (isDuplicate) {
            toast.warning(`User ${selectedSubscriber} already has access to DID ${selectedDid}`);
            return;
        }

        const payload = {
            cloud_id: JSON.parse(localStorage.getItem('creds')).cloud_id,
            did: selectedDid,
            domain: props.domain,
            primary_user: props.sharedDidUser,
            secondary_user: selectedSubscriber
        };

        axios.post(process.env.REACT_APP_API_URL + "createUpdateDidSharing", payload, headers)
            .then(response => {
                
                setTableData(prevState => ({
                    ...prevState,
                    rows: [...prevState.rows, {
                        user: selectedSubscriber,
                        did: selectedDid,
                        delete: (
                            <i className="fa fa-trash" 
                                style={{color: "red", cursor: "pointer"}} 
                                onClick={() => deleteSharedDidsHander(selectedSubscriber, selectedDid)}/>
                        )
                    }]
                }));
                toast.success('DID shared successfully');
            })
            .catch(error => {
                console.error('Error sharing DID:', error);
                toast.error('Failed to share DID');
            });
    }

    return(
        <>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Modal isOpen={props.show} toggle={props.toggleHandler}>
                <ModalHeader toggle={props.toggleHandler}>{"SMS DID For "+ props.sharedDidUser}</ModalHeader>
                <ModalBody>
                    <Card className="main-container">
                        <CardBody className="dropdown-basic">
                            <div className="row">
                                <div className="col-md-12">
                                    <label>{`Users' SMS DID List`}</label>
                                    <select className="form-control" 
                                        onChange={didChangeHandler}
                                    >
                                        {
                                            didsList.map((did, index) => {
                                                return (
                                                    <option key={index} value={did}>{did}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div id="the-basics" style={{marginTop: "20px"}}>
                                <label>{`Choose User to share SMS DID with`}</label>
                                <div className="row">
                                    <div className="col-md-12">
                                        <i className="fa fa-search type-ahead-search-icon"/>
                                        <Typeahead
                                            id="basic-typeahead"
                                            className="search-domains"
                                            labelKey="user"
                                            multiple={false}
                                            options={props.subscriberList}
                                            onChange={subscriberChangeHandler}
                                            placeholder="Search User..."
                                        />
                                        
                                    </div>
                                    <div className="col-md-12" style={{marginTop: "20px", textAlign: "center"}}>
                                        <Button color="primary" onClick={addSubscriberHandler}>Add</Button>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                    <div className="row">
                        <div className="col-md-12">
                            <MDBDataTableV5
                                hover
                                entriesOptions={[5, 10, 20]}
                                entries={5}
                                pagesAmount={4}
                                data={tableData}
                                searchTop
                                searchBottom={false}
                            />
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    )};

export default SharedDids;
